import { Component, ViewContainerRef } from '@angular/core';
import { ToastsManager } from 'ng2-toastr';
import { IframeModalService } from './services/general/fullscreen.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'Start Fire';

  public viewContainerRef: ViewContainerRef;
  iframeUrl$ = this.iframeModalService.iframeUrl$;

  public constructor(
    public toastr: ToastsManager, 
    viewContainerRef: ViewContainerRef,
    private iframeModalService: IframeModalService
  ) {
    this.viewContainerRef = viewContainerRef;

    this.toastr.setRootViewContainerRef(viewContainerRef);
  }

  onActivate(event) {
    window.scroll(0, 0);
  }

}



// WEBPACK FOOTER //
// /app/src/app/app.component.ts